import { useEffect, useRef } from "react";
import { useAuth as useClerkAuth } from "@clerk/react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Turns a Google (Clerk) sign-in into the app's admin session, or signs out a non-approved account.
export const GoogleBridge = () => {
  const { isLoaded, isSignedIn, getToken, signOut } = useClerkAuth();
  const { user, setUser, signedOut, setSignedOut, setGoogleError } = useAuth();
  const busy = useRef(false);

  useEffect(() => {
    if (!isLoaded || !isSignedIn || busy.current) {
      return;
    }
    if (signedOut) {
      busy.current = true;
      signOut().finally(() => { busy.current = false; setSignedOut(false); });
      return;
    }
    if (user !== false) {
      return;
    }
    busy.current = true;
    (async () => {
      try {
        const token = await getToken();
        const { data } = await api.post("/auth/google", {}, { headers: { Authorization: `Bearer ${token}` } });
        setGoogleError("");
        setUser(data);
      } catch (e) {
        setGoogleError(errMsg(e));
        await signOut();
      } finally {
        busy.current = false;
      }
    })();
  }, [isLoaded, isSignedIn, user, signedOut, getToken, signOut, setUser, setSignedOut, setGoogleError]);

  return null;
};
